import React, { useState, useEffect } from 'react'
import { Box, Avatar, Typography, CircularProgress } from '@mui/material'
import moment from 'moment'
import { auditTrailTabStyles } from '../../styles/classes/FormBuilderClasses'
import * as ApiServices from '../../services/ApiService'
import { useSelector } from 'react-redux'
import { useTranslation } from 'react-i18next'
import { TransitionGroup, CSSTransition } from 'react-transition-group'
import '../../styles/auditTrailanimation.css'

const AuditTrailTab = () => {
  const [loading, setLoading] = useState(true)
  const { classes } = auditTrailTabStyles()
  const [audits, setAudits] = useState([])
  const { t } = useTranslation()
  const currentScreenConfig = useSelector(
    state => state.data.currentScreenConfig
  )
  const refresh = useSelector(state => state.loading.refreshAuditTrail)

  useEffect(() => {
    if (refresh) {
      loadAudits()
    }
  }, [refresh])

  useEffect(() => {
    loadAudits()
  }, [])

  const loadAudits = async () => {
    setLoading(true)
    const auditsList = await ApiServices.getAudits(currentScreenConfig.id)
    setLoading(false)
    setTimeout(() => {
      setAudits(auditsList)
    }, 500)
  }

  const auditTrailItem = item => {
    const title = t(`form_builder.audit_trail_status.${item.change.status}`)
    const name = `${item.first_name} ${item.last_name}`
    const initials = name
      .split(' ')
      .map(n => n[0])
      .join('')
      .toUpperCase()
    return (
      <Box className={classes.itemContainer}>
        <Avatar className={classes.avatar} alt={item.name}>
          {initials}
        </Avatar>
        <Box>
          <Typography className={classes.itemActionText}>{title}</Typography>
          <Typography className={classes.userInfoText}>
            {`${item.first_name} ${item.last_name} - ${moment
              .unix(item.date)
              .format('MM/DD/YYYY h:mm A')}`}
          </Typography>
        </Box>
      </Box>
    )
  }

  if (loading) {
    return (
      <Box className={classes.loadingContainer}>
        <CircularProgress />
      </Box>
    )
  }

  return (
    <TransitionGroup component="ul" className={classes.tabContainer}>
      {audits.map((item, index) => {
        return (
          <CSSTransition key={index} timeout={100 * (index + 1)} classNames="item">
            <Box key={item.id}>
              {auditTrailItem(item)}
              {audits?.length - 1 !== index && (
                <Box className={classes.separatorStyle} />
              )}
              {audits?.length - 1 === index && (
                <div className={classes.bottomPadding}/>
              )}
            </Box>
          </CSSTransition>
        )
      })}
    </TransitionGroup>
  )
}

export default AuditTrailTab
